"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RequiredOptionKey = void 0;
class RequiredOptionItem {
    constructor({ key, point, rewardAmount, rewardCurrency, }) {
        this.toJSON = () => ({
            key: this.key,
            point: this.point,
            rewardAmount: this.rewardAmount,
            rewardCurrency: this.rewardCurrency,
        });
        this.key = key;
        this.point = point;
        this.rewardAmount = rewardAmount;
        this.rewardCurrency = rewardCurrency;
    }
}
RequiredOptionItem.fromJSON = (json) => {
    const { key, point, rewardAmount, rewardCurrency } = Object.assign({}, json);
    if (exports.RequiredOptionKey.indexOf(key) === -1)
        throw new Error(`.key must be a one of ${exports.RequiredOptionKey.slice(1).join(', ')}`);
    if (typeof point !== 'number' || Number.isNaN(point))
        throw new Error('.point must be a number');
    if (typeof rewardAmount !== 'number' || Number.isNaN(rewardAmount))
        throw new Error('.rewardAmount must be a number');
    if (rewardCurrency !== undefined && rewardCurrency !== null && typeof rewardCurrency !== 'string')
        throw new Error('.rewardCurrency must be a string');
    return new RequiredOptionItem({ key, point, rewardAmount, rewardCurrency });
};
exports.RequiredOptionKey = [
    'create',
    'resize',
    'modificationRequestForCreate',
    'modificationRequestForResize',
    'expressPerDayForCreate',
    'expressPerDayForResize',
];
exports.default = RequiredOptionItem;
